import { translate } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';
import { SUB_CATEGORY_QUERIES } from './hardcodedTrending';

const subCategorySlug = (id, locale) => translate(`sub_categories.sub_category_${id}.cached_slug`, { locale });

/**
 * Resolves the current page sub category id out of the ones that have an example query.
 * Sub category and nested sub category pages expose `{ category_id, id }` slugs, category pages expose only `{ id }`.
 * @returns {number|undefined}
 */
export const resolveSubCategoryId = () => {
    const { pathParameters = {}, locale } = getContext();
    const { category_id: categorySlugParam, id: subCategorySlugParam } = pathParameters;

    if (!categorySlugParam || !subCategorySlugParam) {
        return undefined;
    }

    return Object.keys(SUB_CATEGORY_QUERIES)
        .map(Number)
        .find((id) => subCategorySlug(id, locale) === subCategorySlugParam);
};
